<template>
    <div class="address">
      <hp5-link-text-tertiary>
        <hp5-icon size="xs" name="system-location-pin" style="fill: var(--color-link-base);"/>
        <a :data-card-rank="rank" :href="detailUrl"> {{ address }} </a>
      </hp5-link-text-tertiary>
    </div>
</template>
  
<script setup>

    const props = defineProps({
        location: Object,
        rank: Number
    })

    const { profile, context } = useFCPModel()
    const { locationDetailUrl } = useUrls(context.value)
 
    const address = computed(() => {
        return `${props?.location?.address?.street1}, ${props?.location?.address?.city}, ${props?.location?.address?.state} ${props?.location?.address?.zip}`
    })

    //const detailUrl = locationDetailUrl(location.id)
    const detailUrl = computed(() => locationDetailUrl(props.location.id))

</script>
  
<style lang="scss" scoped>
  hp5-link-text-tertiary .hp-link-text-tertiary {
    font-size: var(--text-heading-pixels-xxs);
  }
</style>